// React
import React from 'react'



export default class Toggle extends React.Component {

	constructor(props) {
		super(props)
		this.state = { toggle: '' }
		this.handleTouch = this.handleTouch.bind(this)
	}

	componentWillMount() {
		const toggle = this.props.label1
		this.setState({ toggle })
	}

	componentDidUpdate(prevProps, prevState) {
		// Prevent infinite loop by not passing data to parent component if local state remains unchanged
		if (prevState.toggle !== this.state.toggle) {
			// Once state has changed, pass state to parent component
			this.props.onDataChange(this.props.name, this.state.toggle)
		}
	}

	handleTouch() {
		const toggle = this.state.toggle === this.props.label1 ? this.props.label2 : this.props.label1
		this.setState({ toggle })
	}

	render() {
		const { label1, label2 } = this.props
		const toggleClass = this.state.toggle === label1 ? 'left' : 'right'
		return (
			<div className='capps-flex-horiz-center'>
				<div style={{ marginRight: '8px' }}>Update</div>
				{label1 ? <div className='lpa-title' onTouchTap={this.handleTouch}>{label1}</div> : null}
				<div className='lpa-toggle-container' onTouchTap={this.handleTouch}>
					<div className={'lpa-toggler ' + toggleClass} />
				</div>
				{label2 ? <div className='lpa-title' onTouchTap={this.handleTouch}>{label2}</div> : null}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Components/Display/Toggle.js